














import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
    components: {
        mdbNavbar: () => import('@folky-tools/mdbvue/src/components/Navigation/Navbar.vue'),
        mdbNavbarBrand: () => import('@folky-tools/mdbvue/src/components/Navigation/NavbarBrand.vue'),
        mdbNavItem: () => import('@folky-tools/mdbvue/src/components/Navigation/NavbarItem.vue'),
        mdbNavbarNav: () => import('@folky-tools/mdbvue/src/components/Navigation/NavbarNav.vue'),
        mdbNavbarToggler: () => import('@folky-tools/mdbvue/src/components/Navigation/NavbarCollapse.vue'),
        mdbBtn: () => import('@folky-tools/mdbvue/src/components/Components/Button.vue'),
        mdbIcon: () => import('@folky-tools/mdbvue/src/components/Content/Fa.vue'),
        EnterButton: () => import('@/components/shared/EnterButton.vue')
    }
})
export default class NavbarLoggedOut extends Vue {
    @Prop({ type: String, default: '' }) private navbarClasses?: string;
}
